import { useState, useEffect } from "react";
import Loader from "../../modules/layout/components/Loader";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { AuditActionTypeEnumText, AuditEntityTypeEnumText, AuditLevelEnumText, AuditSourceSystemEnumText, LogTypeEnumText } from "../../helpers/EnumeratorHelper";
import { IAxiosGetResponse, IGatewayLog } from "../../interfaces/IUtilities";
import AppBreadcrumb from "../../modules/layout/components/AppBreadcrumb";
import BackButton from "../../modules/layout/components/BackButton";
import { useToast } from "../../modules/layout/components/ToastContext";
import { getById } from "../_request";
import {formatDateTime} from "../../helpers/DateTimeHelper";

const GatewayLogDetails = () => {

    const { t } = useTranslation();
    const { showToast } = useToast();
    const { id } = useParams();
    const [gatewayLog, setGatewayLog] = useState({} as IGatewayLog);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let result = await getById("/api/gatewaylogs/", id!);
                let respStatus = result?.status || result?.response.status;

                if (respStatus === 200) {
                    setGatewayLog(result.data as IGatewayLog);
                    setLoading(false);
                }
                else if (respStatus === 403) {
                    navigate("/error/403");
                }
                else if (respStatus === 401) {
                    navigate("/auth/login");
                }
                else if (respStatus === 500) {
                    navigate("/error/500");
                }
                else {
                    throw new Error(t('StatusCode', {code: String(respStatus)}));
                }
            } catch (error) {
                setLoading(false);
                console.log(t('ConnectionError', {error: String(error)}));
                showToast(t('ConnectionError', {error: String(error)}), 'error');
                navigate("/gateway-logs/list");
            }
        }
        fetchData();

    }, [id]);


    return (
        <div className="container mt-4 gg-container-card">
            <AppBreadcrumb
                items={[
                    {title: t("Home"), href: "/"},
                    {title: t("GatewayLogList"), href: "/gateway-logs/list"},
                    {title: t('LogId', { id }), },
                ]}/>

            <h3>{ t('GatewayLogDetails')}</h3>

            {loading && (<Loader />)}

            <div className="card">
                {/*<div className="card-header">
                    <h4>{gatewayLog.auditId}</h4>
                </div>*/}
                <div className="card-body">
                    <p><strong>{ t('Id') }:</strong> {gatewayLog.logId}</p>
                    <p><strong>{ t('UserId') }:</strong> {gatewayLog.userId}</p>
                    <p><strong>{t('UserName')}:</strong>{" "}
                        {gatewayLog.userName && gatewayLog.userName.length > 0 ? 
                            gatewayLog.userName :
                            <i className="text-danger">{t('UserRemoved')}</i>
                        }
                    </p>
                    <p><strong>{t('FullName')}:</strong>{" "}
                        {gatewayLog.fullName && gatewayLog.fullName.length > 0 && gatewayLog.fullName}
                    </p>
                    <p><strong>{ t('LogType') }:</strong> {LogTypeEnumText[gatewayLog.logType]}</p>
                    <p><strong>{ t('AuditLevel') }:</strong> {AuditLevelEnumText[gatewayLog.auditLevel]}</p>
                    <p><strong>{ t('ClassName')}:</strong> {gatewayLog.className}</p>
                    <p><strong>{ t('CorrelationId')}:</strong> {gatewayLog.correlationId}</p>
                    <p><strong>{ t('LogMessage') }:</strong> {gatewayLog.logMessage}</p>
                    <p><strong>{ t('CreatedAt')}:</strong> {formatDateTime(gatewayLog.createdAt)}</p>
                </div>
                <div className="card-footer bg-transparent">
                    <BackButton goTo={"/gateway-logs/list"}/>
                </div>
            </div>

        </div>
    )
}
export default GatewayLogDetails;
